import { createStandaloneToast } from '@chakra-ui/react';

const { toast } = createStandaloneToast();

export const showToast = (message, status = 'error', duration = 5000) => {
  toast({
    title: message,
    status: status,
    duration: duration,
    isClosable: true,
    position: 'top-right'
  });
};